import { render } from "./Policy.vue?vue&type=template&id=0bef72c6&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"

import "./Policy.vue?vue&type=style&index=0&id=0bef72c6&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/Laravel/mistock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bef72c6"]])

export default __exports__